import React from 'react'
import PropTypes from 'prop-types'

const Embed = (props) => {
    const { embedUrl, caption } = props
    return (
        <>
            <iframe
                style={{ width: '100%' }}
                height='320'
                frameBorder='0'
                allowFullScreen={true}
                src={embedUrl}
                className='embed-tool__content'
            ></iframe>
            {caption && caption !== '' && (
                <div className={'cdx-input embed-tool__caption'}>
                    <p>{caption}</p>
                </div>
            )}
        </>
    )
}

Embed.propTypes = {
    embedUrl: PropTypes.string,
    caption: PropTypes.string,
}

export default Embed
